import React from "react";
import DeviceInfoBar from './DeviceInfoBar'

import DeviceInfoPanel from './DeviceInfoPanel'
import DeviceImagePanel from './DeviceImagePanel'

export default class DeviceDetailContent extends React.Component {
  
  render() {
    return (
      <div>
        <DeviceInfoBar data={this.props.data}/>
        <div className="container-fluid x-container-fluid">
          <div className="row">
              <DeviceInfoPanel data={this.props.data}/>
              <DeviceImagePanel data={this.props.data}/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DeviceDetailContent.js